import { render, staticRenderFns } from "./TemplatesLista.vue?vue&type=template&id=342bfc35&scoped=true&"
import script from "./TemplatesLista.vue?vue&type=script&lang=js&"
export * from "./TemplatesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342bfc35",
  null
  
)

export default component.exports